import { render, staticRenderFns } from "./ds-slider-custom-scale.vue?vue&type=template&id=80a4fab4&scoped=true&"
import script from "./ds-slider-custom-scale.vue?vue&type=script&lang=js&"
export * from "./ds-slider-custom-scale.vue?vue&type=script&lang=js&"
import style0 from "./ds-slider-custom-scale.vue?vue&type=style&index=0&id=80a4fab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a4fab4",
  null
  
)

component.options.__file = "ds-slider-custom-scale.vue"
export default component.exports